import React, { Fragment } from 'react'
import { Container, Col, Row, Button, Card, CardBody, Input } from 'reactstrap';
import { ModalAntibiogram } from '../../../components/micro/antibiogram/ModalAntibiogram';
import { useAntibiogram } from '../../../hooks/micro/useAntibiogram';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DialogAntibiograms } from '../../../components/micro/antibiogram/DialogAntibiograms';

export const IndexAntibiogram = () => {

    const {
        antibiograms, antibiotics, method, validaciones, onChangeAntibiotics, antibioticsSelected,
        antibiogram,
        handleInputChange, loading,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleSearch,
        modalAntibiograms, antibiogramsSelectedTable, closeDialog, openDialog,
        showDeleteAlert, closeDeleteAlert, modalAlert,
        handleClearAntibiagram, handleExportExcelAntibiagram, loadingExport, searchAntibiagram,
        closeDialogA, openDeleteAlert


    } = useAntibiogram();    
       
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
    
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_mic_antibiogram)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_mic_antibiogram)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };


    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                    <TitleDataTable
                                        titleTable="Listado de Antibiogramas"
                                        buttonActions={handleExportExcelAntibiagram}
                                        titleButton="Listado de Antibiogramas"
                                        isDisbled={loadingExport}
                                        loadingIsDisabled={loadingExport}
                                        titleCreate="Crear Laboratorio"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchAntibiagram}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearAntibiagram}

                                    />
                                </Col>

                                <div className="table-responsive">
                                    <DataTable
                                        value={antibiograms}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="antibiogram" header="Antibiogramas" headerStyle={headerStyle} style={cellStyle} />
                                       
                                        <Column
                                            header="No. Antibióticos"
                                            body={(rowData) => {
                                                const total = rowData.antibiotics ? rowData.antibiotics.length : 0;
                                                return (
                                                    <span
                                                        onClick={() => openDialog(rowData)}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#fff",
                                                            backgroundColor: "#25acd4ff",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            fontSize: "10px",
                                                            display: "inline-block",
                                                            fontWeight: "bold"
                                                        }}
                                                        title="Ver antibióticos"
                                                    >
                                                        {total} {total === 1 ? "Antibiótico" : "Antibióticos"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />

                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                                
                            </CardBody>
                        </Card>
                         
                        {showDeleteAlert && (
                            <AlertDataTable
                                titleAlert="Eliminar Antibiagrama"
                                visibleAlert={modalAlert}
                                onHideAlert={closeDeleteAlert}
                                sizeAlert="medium-dialog delete-method"
                                messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el antibiagram?"
                                alert1={true}
                                titleAlert1={antibiogram}
                                buttonAcept
                                titleNotLoading="Eliminar"
                                titleDanger="Cancelar"
                                actionAcept={saveDelete}
                            />

                        )}
                        
                        <ModalAntibiogram
                            {...{
                                modal, modalTitle, closeDialogA, method, onChangeAntibiotics, antibioticsSelected,
                                validaciones,
                                antibiogram, antibiotics,
                                handleInputChange, loading,
                                saveCreate, saveUpdate, saveDelete
                            }}
                        />

                        <DialogAntibiograms
                            {...{
                                closeDialog, openDialog, modalAntibiograms, antibiogramsSelectedTable

                            }}
                        />
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}
